import { Dispatch, SetStateAction, useState } from "react";
import Input from "../lib/Input";
import CostColumns from "../lib/CostColumns";
import OperationLayout from "../lib/OperationLayout";
import VolumeDiscount from "../lib/VolumeDiscount";
import useOperationContext from "../lib/useOperationContext";
import SelectNamedTimeCost from "../lib/SelectNamedTimeCost";
import OperationHeader from "../lib/OperationHeader";
import MaterialNameSelect from "../MaterialNameSelect";
import EditableCostColumns from "../lib/EditableCostColumns";
import { hasSomeValidationErrorsInFields } from "../lib/getValidationErrors";
import { Operation } from "../lib/types";

export default function CuttingOperations() {
  const { operationData: data } = useOperationContext();
  const { id, validation_errors } = data;
  const expandByDefault = hasSomeValidationErrorsInFields({
    errors: validation_errors,
    expandedPanelFields: [
      "discount_rates",
      "hourly_rate",
      "min_part_cost",
      "markup",
    ],
  });
  const [expand, setExpand] = useState(expandByDefault);

  return (
    <OperationLayout
      id={id as string}
      left={<Left operation={data} expand={expand} setExpand={setExpand} />}
      right={<Right expand={expand} />}
    />
  );
}

function Left({
  operation,
  expand,
  setExpand,
}: {
  operation: Operation;
  expand: boolean;
  setExpand: Dispatch<SetStateAction<boolean>>;
}) {
  return (
    <div className="w-full flex flex-col p-2 pb-1 gap-2 items-start">
      <OperationHeader
        operation={operation}
        expand={expand}
        setExpand={setExpand}
      />
      <div className="flex gap-2">
        <Input
          label="Cutting speed"
          keyPath={["cutting_speed"]}
          nunit="length"
          dunit="time"
          width={100}
        />
        <Input label="Pierce time" keyPath={["pierce_time"]} unit="time" />
        <Input label="Cut length" keyPath={["cut_length"]} unit="length" />
      </div>
      <div className="flex gap-2">
        <MaterialNameSelect width={120} />
        <Input
          label="Thickness"
          keyPath={["thickness"]}
          unit="length"
          width={70}
        />
      </div>
      <div className="flex gap-2">
        <Input label="Pierces" keyPath={["pierces"]} width={60} />
        <Input label="Setup time" keyPath={["setup_time"]} unit="time" />
        <Input label="Cycle time" keyPath={["cycle_time"]} unit="time" />
      </div>
      {expand && (
        <div className="w-full flex gap-2 justify-between">
          <VolumeDiscount />
          <div className="flex flex-col gap-2">
            <SelectNamedTimeCost
              label="Hourly Rate"
              keyPath={["hourly_rate"]}
            />
            <Input
              label="Min. cost/part"
              keyPath={["min_part_cost"]}
              unit="currency"
              width={100}
            />
          </div>
          <div className="flex flex-col justify-end gap-6">
            <div className="text-xs text-gray-400 self-end">Cost</div>
            <Input label="Markup" keyPath={["markup"]} suffix="%" width={60} />
          </div>
        </div>
      )}
    </div>
  );
}

function Right({ expand }: { expand: boolean }) {
  return (
    <>
      {expand && <EditableCostColumns />}
      <CostColumns />
    </>
  );
}
